import { catalogPageReducer } from './catalogPage';
import { sharedReducer } from './sharedReducer';
import { combineReducers } from './combineReducers';

export const reducer = combineReducers({
    shared: sharedReducer,
    catalogPage: catalogPageReducer,
});
